import { observer } from 'mobx-react-lite'
import { SkeletonList } from '@/components/Skeleton'
import { match } from '@/utils/pattern-match-util'
import {
  ServiceTypeListItem,
  ServiceTypesDialog,
  ServiceTypeSkeleton,
} from '@/features/dashboard/components/ServiceTypesDialog/index'
import type { ServiceSelectionViewModel } from '@/features/dashboard/DashboardView/ServiceSelectionViewModel'

interface ServiceTypesDialogContainerProps {
  vm: ServiceSelectionViewModel
}

/**
 * The ServiceTypesDialogContainer
 */
export const ServiceTypesDialogContainer = observer(
  ({ vm }: ServiceTypesDialogContainerProps) => {
    return (
      <>
        <ServiceTypesDialog
          isOpen={vm.serviceTypesModalVm.showing}
          onClose={vm.serviceTypesModalVm.close}
          isCloseDisabled={vm.isPending}
          testId="service-types-dialog"
        >
          {vm.listPublishedLegends.pending ? (
            <SkeletonList count={4}>
              <ServiceTypeSkeleton />
            </SkeletonList>
          ) : (
            vm.availableServiceTypes.map((type) => {
              const isCreatingJobOfType =
                vm.selectedServiceType === type && vm.createDraft.pending
              return match(type, {
                Tax: (
                  <ServiceTypeListItem
                    key={type}
                    title="Tax filing"
                    description="Quickly file your personal or business taxes with expert support."
                    icon="docs"
                    onAction={() => vm.selectServiceType('Tax')}
                    isDisabled={vm.isPending}
                    isPending={isCreatingJobOfType}
                    testId="service-types-tax-filing-item"
                  />
                ),
                Consultation: (
                  <ServiceTypeListItem
                    key={type}
                    title="Advisory"
                    description="Schedule a call and get your questions answered from a Pro."
                    icon="chat-bubbles"
                    onAction={() => vm.selectServiceType('Consultation')}
                    isDisabled={vm.isPending}
                    isPending={isCreatingJobOfType}
                    testId="service-types-consultation-item"
                  />
                ),

                Bookkeeping: (
                  <ServiceTypeListItem
                    key={type}
                    title="Bookkeeping"
                    description="Keep your finances organized and your books up-to-date."
                    icon="buildings"
                    onAction={() => vm.selectServiceType('Bookkeeping')}
                    isDisabled={vm.isPending}
                    isPending={isCreatingJobOfType}
                    testId="service-types-bookkeeping-item"
                  />
                ),

                Misc: (
                  <ServiceTypeListItem
                    key={type}
                    title="Other services"
                    description="Explore additional services tailored to your needs."
                    icon="rocket"
                    onAction={() => vm.selectServiceType('Misc')}
                    isDisabled={vm.isPending}
                    isPending={isCreatingJobOfType}
                    testId="service-types-misc-item"
                  />
                ),
              })
            })
          )}
        </ServiceTypesDialog>
      </>
    )
  },
)
